"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientDisposeReason = exports.ClientAuthorization = void 0;
var ClientAuthorization;
(function (ClientAuthorization) {
    ClientAuthorization["READ"] = "Read";
    ClientAuthorization["WRITE"] = "Write";
    ClientAuthorization["OWNER"] = "Owner";
})(ClientAuthorization || (exports.ClientAuthorization = ClientAuthorization = {}));
var ClientDisposeReason;
(function (ClientDisposeReason) {
    ClientDisposeReason["AUTHORIZATION_CHANGED"] = "AuthorizationChanged";
    ClientDisposeReason["DISCONNECT"] = "Disconnect";
    ClientDisposeReason["PITCHER_SHUTDOWN"] = "PitcherShutdown";
})(ClientDisposeReason || (exports.ClientDisposeReason = ClientDisposeReason = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21lc3NhZ2VzL2NsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFjQSxJQUFZLG1CQUlYO0FBSkQsV0FBWSxtQkFBbUI7SUFDN0Isb0NBQWEsQ0FBQTtJQUNiLHNDQUFlLENBQUE7SUFDZixzQ0FBZSxDQUFBO0FBQ2pCLENBQUMsRUFKVyxtQkFBbUIsbUNBQW5CLG1CQUFtQixRQUk5QjtBQUVELElBQVksbUJBSVg7QUFKRCxXQUFZLG1CQUFtQjtJQUM3QixxRUFBOEMsQ0FBQTtJQUM5QyxnREFBeUIsQ0FBQTtJQUN6QiwyREFBb0MsQ0FBQTtBQUN0QyxDQUFDLEVBSlcsbUJBQW1CLG1DQUFuQixtQkFBbUIsUUFJOUIifQ==